// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"756":"a46da433","817":"5162d747"}[chunkId] + ".chunk.css";
};